import React from "react";

const IconArrowUp = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
        strokeLinecap="round" 
        strokeLinejoin="round"
		className={className}
	>
		<path d="M18 15l-6-6-6 6" />
	</svg>
);

export default IconArrowUp;
